import { safeId } from '../../../../../domain';
import { CompanyUsersKeys } from '../company-users.key';
import { Places } from '../../../../route-consts';
/** Prefixo dos nomes deste arquivo na intencao - unico na aplicacao (ver `url-codes.test.ts`). */
const PREFIX = 'ud';
/** Os parametros deste place: vao para o endereco. */
const P = {
    /** De quem e a ficha aberta na area de usuarios da empresa. */
    CompanyUserTarget: `${PREFIX}a`
};
/**
 * A ficha de um usuario da empresa.
 *
 * Substituiu os dois dialogos que existiam antes - corrigir o CPF e atribuir
 * colaboradores. Eram duas portas para o mesmo assunto, e cada uma mostrava um
 * pedaco: quem abrisse "editar" via um campo de CPF e concluia, com razao, que era
 * so isso que dava para configurar.
 *
 * E TELA, e nao dialogo: sao quatro secoes, uma delas uma lista que rola. A regra do
 * projeto manda o dialogo ser filho quando ele e desenhado POR CIMA da tela que
 * continua atras; aqui a lista sai de cena, entao a ficha ocupa o lugar dela - como
 * o detalhe do colaborador faz.
 */
export class CompanyUserDetailKeys extends CompanyUsersKeys {
    get place() {
        return Places.companyUserDetail;
    }
    /** De quem e a ficha. Sem isto ela nao tem do que falar, e volta para a area. */
    get target() {
        return safeId(this._intent.getParameterAsNumber(P.CompanyUserTarget));
    }
    set target(value) {
        this._intent.setParameter(P.CompanyUserTarget, value);
    }
}
//# sourceMappingURL=company-user-detail.key.js.map